export default __webpack_public_path__ + "static/media/Allorado.84644c5e.svg";